import { useAuthenticationContext } from 'contexts';
import { messages } from 'i18n';
import { ExtendedMarketRequest } from 'types';
import { getEnvironment } from 'utils/environment';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

const url = 'https://localhost:3003/portal-automation';

export function usePortalAutomation() {
  const { getIdToken } = useAuthenticationContext();
  const { submission } = useSubmissionsWorkspace();

  return async (marketRequest: ExtendedMarketRequest): Promise<{ success: boolean; message: string }> => {
    const { submissionId } = marketRequest.market;

    const environment = getEnvironment();

    try {
      const idToken = await getIdToken();
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          insuranceProductId: marketRequest.insuranceProduct?.id,
          submissionId,
          isDemo: submission?.isDemo ?? false,
          environment,
          bearerToken: idToken,
        }),
      });

      // Check if the response status is successful
      if (response.ok) {
        return { success: true, message: messages.portalAutomation.portalAutomationStartedSuccessfully };
      }

      // Handle specific error status codes
      if (response.status === 422) {
        // Service unavailable - portal automation at capacity
        return { success: false, message: messages.portalAutomation.portalAutomationAlreadyRunning };
      }

      // Handle other HTTP errors
      return { success: false, message: `${messages.portalAutomation.portalAutomationFailed}. ${response.statusText}` };
    } catch (error: unknown) {
      // Network errors or other fetch failures
      return {
        success: false,
        message: `${messages.portalAutomation.portalAutomationFailed}. ${
          error instanceof Error ? error.message : messages.general.operationFailed
        }`,
      };
    }
  };
}
